import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'history',
        component: LayoutDefaultComponent,
        canActivate: [UserAuthGuard, PermissionGuard],
        data: { permissions: ['GET_TRANSACTIONS', 'GET_BATCH'] },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/history/history.component').then((x) => x.HistoryComponent),
          },
          {
            path: 'transactions',
            loadComponent: () => import('./pages/history/history.component').then((x) => x.HistoryComponent),
          },
          {
            path: 'requests',
            canActivate: [PermissionGuard],
            data: { permissions: 'REQUEST_VIEW' },
            loadComponent: () => import('./pages/requests/requests.component').then((x) => x.RequestsComponent),
          },
          {
            path: 'payments',
            canActivate: [PermissionGuard],
            data: { permissions: 'GET_TRANSACTIONS' },
            loadComponent: () =>
              import('./pages/payment-history/payment-history.component').then((x) => x.PaymentHistoryComponent),
          },
        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class TransactionsRoutingModule { }
